'use client';

import { useSearchParams } from 'next/navigation';
import { Suspense } from 'react';

function EmbedAwareInner({ children }: { children: React.ReactNode }): React.JSX.Element | null {
  const searchParams = useSearchParams();
  if (searchParams.get('embed') === '1') {
    return null;
  }
  return <>{children}</>;
}

export function EmbedAware({ children }: { children: React.ReactNode }): React.JSX.Element {
  return (
    <Suspense fallback={children}>
      <EmbedAwareInner>{children}</EmbedAwareInner>
    </Suspense>
  );
}
